<template>
  <div class="chapter chapter2">
    <video autoplay muted loop id="redVideo" :src="video">
    </video>
    <div v-if="slide === 1" class="red-container">
      <Header v-bind:currentTimer="currentTimer" v-bind:strikes="collectedStrikes" :key="headerKey" styleType="red" hideLogo="false" />
      <div class="content-container">
        <div class="container h-100 pt-5">
          <div class="row justify-content-center">
            <div class="col-8">
              <div class="mail-container">
                <div class="mail-header">
                  <div class="mail-header-top">
                    <img class="icon" src="@/assets/envelope.svg" width="32" height="32" />
                    <span class="title">Tabbot E-Mailer Pro 2000</span>
                  </div>
                  <div class="mail-header-functions">
                    <div class="row justify-content-center">
                      <div class="col">
                        <img class="icon" src="@/assets/reply-fill.svg" width="16" height="16" />
                        <span class="label">Reply</span>
                      </div>
                      <div class="col">
                        <img class="icon" src="@/assets/reply-all-fill.svg" width="16" height="16" />
                        <span class="label">Reply All</span>
                      </div>
                      <div class="col">
                        <img class="icon" src="@/assets/forward-fill.svg" width="16" height="16" />
                        <span class="label">Forward</span>
                      </div>
                      <div class="col">
                        <img class="icon" src="@/assets/bookmark-plus-fill.svg" width="16" height="16" />
                        <span class="label">Mark</span>
                      </div>
                      <div class="col">
                        <img class="icon" src="@/assets/trash.svg" width="16" height="16" />
                        <span class="label">Delete</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mail-content">
                  <div class="from">
                    <span class="label">From:</span>
                    <span class="text">{{ $t('chapter2.slide1.from') }}</span>
                  </div>
                  <div class="to">
                    <span class="label">To:</span>
                    <span class="text">{{ $t('chapter2.slide1.to') }}</span>
                  </div>
                  <div class="mail-text" v-html="$t('chapter2.slide1.text')"></div>
                  <div class="mail-text" v-html="$t('chapter2.slide1.code')"></div>
                </div>
                <div class="mail-footer">
                </div>
              </div>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-10 col-sm-10 col-md-10 col-lg-6 col-xl-5 pt-5 text-center">
              <h4>{{ $t('chapter2.slide1.question') }}</h4>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-10 col-sm-10 col-md-10 col-lg-6 col-xl-5 pt-1">
              <div v-if="currentRiddleError" class="error-msg pb-2 text-center">{{ $t('common.error.wrongAnswer') }}</div>
              <form>
                <div class="row form-group justify-content-center">
                  <div class="col-12 col-sm-12 col-md-5 col-lg-8">
                    <input type="text" class="form-control" v-model="riddles[0].input" />
                  </div>
                  <div class="col-6 col-sm-6 col-md-3 col-lg-4 pt-3 pt-md-0">
                    <button class="btn btn-danger" @click="checkSolution(0)">{{ $t('common.button.next') }}</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Footer type="red" />
      <div class="hints red">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-12 text-center">
              <form>
                <div>
                  <span class="hints-text">{{ $t('common.hints') }} </span>
                  <button class="btn" @click="showHint(0, 0)">1</button>
                  <button v-if="riddles[0].hintsShown[0]" class="btn" @click="showHint(0, 1)">2</button>
                  <button v-if="riddles[0].hintsShown[1]" class="btn" @click="showHint(0, 2)">3</button>
                  <button v-if="riddles[0].hintsShown[2]" class="btn" @click="showHint(0, 3)">4</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="riddles[0].showHint[0]" class="overlay" @click="closeHint">
      <div class="container h-100">
        <div class="row justify-content-center h-100">
          <div class="col-10 col-md-6 col-lg-4 my-auto p-5 hint-col red h4 text-center">
            {{ $t('chapter2.slide1.hints.1') }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="riddles[0].showHint[1]" class="overlay" @click="closeHint">
      <div class="container h-100">
        <div class="row justify-content-center h-100">
          <div class="col-10 col-md-6 col-lg-4 my-auto p-5 hint-col red h4 text-center">
            <img src="@/assets/Google_Maps_icon.svg" alt="Google Maps Icon" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="riddles[0].showHint[2]" class="overlay" @click="closeHint">
      <div class="container h-100">
        <div class="row justify-content-center h-100">
          <div class="col-10 col-md-6 col-lg-4 my-auto p-5 hint-col red h4 text-center">
            {{ $t('chapter2.slide1.hints.3') }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="riddles[0].showHint[3]" class="overlay" @click="closeHint">
      <div class="container h-100">
        <div class="row justify-content-center h-100">
          <div class="col-10 col-md-6 col-lg-4 my-auto p-5 hint-col red h4 text-center">
            {{ $t('chapter2.slide1.hints.4') }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="riddles[0].showSolution" class="overlay">
      <div class="container h-100">
        <div class="row justify-content-center h-100">
          <div class="col-10 col-md-6 col-lg-4 my-auto p-5 hint-col red h4 solution">
            <strong>{{ $t('common.caution') }}!</strong><br />
            {{ $t('common.solutionText') }}<br />
            <br />
            <div class="solution"><strong>{{ $t('common.solutionLabel') }}<br />{{ riddles[0].solutionText }}</strong></div>
            <br />
            <button class="btn btn-danger" @click="nextRiddle">{{ $t('common.button.next') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import axios from 'axios'

export default {
  name: 'Chapter2',
  components: {
    Header, Footer
  },
  data: function () {
    return {
      pw: 'asdkfjhtmnbvasdfknedsfDSF',
      chapter: 2,
      slide: 1,
      currentTimer: 0,
      currentRiddle: 0,
      currentRiddleError: false,
      riddles: [
        {
          input: '',
          solutions: ['der papst', 'papst', 'the pope', 'pope'],
          solutionText: 'Der Papst / the pope',
          solutionTimer: 10,
          hintsShown: [false, false, false, false],
          showHint: [false, false, false, false],
          showSolution: false,
          causesStrikes: [true, true, true, true],
          strikeValues: [60, 60, 60, 60],
          strikes: [0, 0, 0, 0],
          riddleSlide: 1,
          nextSlide: 2
        }
      ],
      strikes: [0]
    }
  },
  computed: {
    video: function () {
      return 'https://tabbot-central.b-cdn.net/video/BinaryNumbers2.mp4'
    },
    collectedStrikes: function () {
      const strikes = []
      for (let r = 0; r < this.riddles.length; r++) {
        strikes.push(this.riddles[r].strikes)
      }
      return strikes
    }
  },
  methods: {
    calcTimer: function () {
      const d = new Date()
      let riddleTimer = 0
      for (let i = 0; i <= this.currentRiddle; i++) {
        riddleTimer += this.riddles[i].solutionTimer * 60
      }
      this.currentTimer = (this.$store.state.currentTimer + riddleTimer) - (d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds())
      if (this.currentTimer > 0) {
        setTimeout(this.calcTimer, 500)
      } else {
        this.currentTimer = 0
        setTimeout(this.calcTimer, 500)
      }
      if (this.currentTimer === 0 && this.slide === this.riddles[this.currentRiddle].riddleSlide) {
        this.riddles[this.currentRiddle].showSolution = true
      }
    },
    navigateTo: function (slide) {
      event.preventDefault()
      this.slide = slide
    },
    checkSolution: function (riddle) {
      event.preventDefault()
      this.currentRiddleError = false
      if (this.riddles[riddle].solutions.includes(this.riddles[riddle].input.trim().toLowerCase())) {
        // Chapter finnished?
        if (this.currentRiddle + 1 >= this.riddles.length) {
          this.finishChapter()
          return
        }
        this.currentRiddle += 1
        this.slide = this.riddles[riddle].nextSlide
      } else {
        this.currentRiddleError = true
      }
    },
    saveHints: function () {
      const cookieDate = new Date()
      let expires = ';expires='
      cookieDate.setTime(cookieDate.getTime() + 86400000)
      expires += cookieDate.toGMTString()
      const strikes = []
      for (let r = 0; r < this.riddles.length; r++) {
        strikes.push(this.riddles[r].strikes)
      }
      document.cookie = 'strikes-' + this.chapter + '=' + JSON.stringify(strikes) + expires
    },
    showHint: function (riddle, hint) {
      event.preventDefault()
      this.riddles[riddle].showHint[hint] = true
      this.riddles[riddle].hintsShown[hint] = true
      this.riddles[riddle].strikes[hint] = this.riddles[riddle].strikeValues[hint]
      this.headerKey += 1
      this.saveHints()
    },
    closeHint: function () {
      for (const riddle in this.riddles) {
        for (const hint in this.riddles[riddle].showHint) {
          this.riddles[riddle].showHint[hint] = false
        }
      }
    },
    nextRiddle: function () {
      for (const riddle in this.riddles) {
        this.riddles[riddle].showSolution = false
      }
      // Chapter finnished?
      if (this.currentRiddle + 1 >= this.riddles.length) {
        this.finishChapter()
        return
      }
      this.slide = this.riddles[this.currentRiddle].nextSlide
      this.currentRiddle += 1
    },
    finishChapter: function () {
      let strikes = 0
      for (let r = 0; r < this.riddles.length; r++) {
        for (let s = 0; s < this.riddles[r].strikes.length; s++) {
          strikes += this.riddles[r].strikes[s]
        }
      }
      this.currentTimer -= strikes
      if (this.currentTimer < 0) {
        this.currentTimer = 0
      }
      // SEND USER TO BACKEND
      axios.get('http://admin.tabbot-central.com/setChapterData.php', {
        params: {
          token: this.pw,
          username: this.$store.state.username,
          teamname: this.$store.state.teamname,
          chapter: this.chapter,
          time: this.currentTimer
        }
      }).then(response => {
        console.log(response)
        this.$store.commit('updateGameState', 'beforeChapter' + (this.chapter + 1))
      }).catch(error => {
        console.log(error)
        this.errorType = 'couldNotLoginUser'
        this.loginError = true
      })
    }
  },
  created: function () {
    const cookies = document.cookie.split('; ').reduce((prev, current) => {
      const [name, value] = current.split('=')
      prev[name] = value
      return prev
    }, {})
    if (cookies['strikes-' + this.chapter]) {
      const strikes = JSON.parse(cookies['strikes-' + this.chapter])
      for (let r = 0; r < this.riddles.length; r++) {
        this.riddles[r].strikes = strikes[r]
      }
    }
    this.calcTimer()
  }
}
</script>
